import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Failed to find the root element');
} else {
  try {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (e) {
    console.error('Failed to mount React app:', e);
    rootElement.innerHTML =
      '<div style="color:#0B0C10; padding: 20px;">Failed to load application. See console for details.</div>';
  }
}
